class ModalEvent {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    const brandModalTrigger = document.querySelector(".js-brand-trigger")
    const brandModalContent = document.querySelector(".js-brand-modal")
    const brandModalOverlay = document.querySelector(".modal-overlay")
    const brandModalClose = document.querySelector(".modal-close")
    const body = document.querySelector("body")

    const closeEleAry = [
      brandModalOverlay,
      brandModalClose
    ]

    if(brandModalTrigger){

      brandModalTrigger.addEventListener("click", () => {
        brandModalContent.classList.add("is-active")
        body.classList.add("is-scroll")
      })

      closeEleAry.forEach(el => {
        el.addEventListener("click", () => {
          brandModalContent.classList.remove("is-active")
          body.classList.remove("is-scroll")
        })
      })

    }


  }
}
